import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import dayjs from 'dayjs';
import ListDataPage from '../../../components/pages/ListDataPage';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllPayments = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (
    payment_id: string,
    subscription_id: string
  ): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () => navigate(`/sales/payments/edit-payments/${payment_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      // callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    }
    // {
    //   eventKey: '3',
    //   label: 'Create Subscription',
    //   type: 'function',
    //   callback: () =>
    //     navigate(
    //       `/sales/subscription/create-subscription?institute_id=${sales_institute_id}`
    //     ),
    //   className: 'text-danger'
    // },
    // {
    //   eventKey: '3',
    //   label: 'Create Order',
    //   type: 'function',
    //   callback: () =>
    //     navigate(
    //       `/sales/order/create-order?institute_id=${sales_institute_id}`
    //     ),
    //   className: 'text-danger'
    // },
    // {
    //   eventKey: '3',
    //   label: 'Record payment',
    //   type: 'function',
    //   callback: () =>
    //     navigate(
    //       `/sales/payments/add-payment?subscription_id=${subscription_id}`
    //     ),
    //   className: 'text-danger'
    // }
  ];

  const columns = [
    { accessorKey: 'payment_id', header: 'Payment ID' },
    {
      accessorKey: 'subscription.sales_institute.institute_name',
      header: 'Institute Name'
    },
    { accessorKey: 'amount_paid', header: 'Amount' },
    {
      accessorKey: 'payment_date',
      header: 'Payment Date',
      cell: ({ row }: { row: any }) => (
        <span>{dayjs(row.original.payment_date).format('DD/MM/YYYY ')}</span>
      )
    },
    { accessorKey: 'transaction_id', header: 'Transaction ID' },
    { accessorKey: 'CDC_FLAG', header: 'Status' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.payment_id,
                row.original.subscription_id
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useSalesPayments}
      entityName="All Payments"
      columns={columns}
    />
  );
};

export default AllPayments;
